<template>
  <div class="personal-center" @click.stop="handleUser">
    <img src="~@/assets/image/entry/entry_my.png" alt="" />
    <span>我的</span>
  </div>
</template>

<script>
export default {
  name: "personalCenter",
  methods: {
    async handleUser(){
      const userInfo = await this.$getGroupUserInfo();
      if(!userInfo){
        this.$router.push('/user');
      }else{
        this.$router.push('/userguide');
      }
    },
  }
};
</script>

<style scoped lang='less'>
  .personal-center{
    position: fixed;
    right: .5333rem;
    bottom: 2.08rem;
    width: 1.2rem;
    height: 1.2rem;
    background: #F1F5F8;
    box-shadow: 0 .026667rem .053333rem 0 #3B6D9C;
    border: 1px solid #FFFEFE;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img{
      width: .56rem;
    }
    span{
      font-size: .266667rem;
      color: #3B6D9C;
      line-height: .373333rem;
      margin-top: .026667rem;
    }
  }
</style>
